import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/scss';

export default function (element, data) {
    const swiperOptions = {
        modules: [Autoplay, Navigation],
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 5,
        centeredSlides: true,
        speed: data.transition ? data.transition : 900,
        autoplay: data.timeout ? {delay: data.timeout} : false,
    };

    let sliders = element.querySelectorAll('.block-swiper');

    sliders.forEach(swiperContainer => {
        let swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
        let slides = swiperContainer.querySelectorAll('.swiper-slide');
        let nextBtn = swiperContainer.querySelector(".swiper-button-next");
        let prevBtn = swiperContainer.querySelector(".swiper-button-prev");

        if (slides.length > 1 && slides.length < 8) {
            slides.forEach(slide => {
                const cloneSlide = slide.cloneNode(true);
                swiperWrapper.appendChild(cloneSlide);
            });
        }
    
        if (slides.length > 1 && nextBtn && prevBtn) {
            nextBtn.style.display = 'block';
            prevBtn.style.display = 'block';

            swiperOptions.navigation = {
                nextEl: nextBtn,
                prevEl: prevBtn,
            };
        } else if (nextBtn && prevBtn) {
            nextBtn.style.display = 'none';
            prevBtn.style.display = 'none';
        }
        
        element.swiper = new Swiper(swiperContainer, swiperOptions);
    });
};